

















































import {Component, Vue} from "vue-property-decorator";

@Component
export default class Header extends Vue {
    public scrolled: boolean = false;
    public opened: boolean = false;

    mounted() {
        this.scrolled = window.scrollY != 0;
        window.addEventListener("scroll", this.handleScroll);

        this.$router.beforeEach((to, from, next) => {
            this.opened = false;
            next();
        });
    }

    handleScroll() {
        this.scrolled = window.scrollY != 0;
    }
}
